import { useEffect, useRef, useState } from "react";
import SlickSlider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { isTablet, isMobile } from "react-device-detect";
import AOS from "aos";
import "aos/dist/aos.css";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
const Slider = SlickSlider as any;

const items = [
    { id: 1, title: "Launchpad", desc: "Get early access to promising Web3 projects before they go public.", image: "https://tinyblock.s3.ap-southeast-1.amazonaws.com/v2.mp4" },
    {
        id: 2, title: "Staking", desc: "Stake tokens to earn rewards, secure allocations, and unlock platform benefits.", image: "https://tinyblock.s3.ap-southeast-1.amazonaws.com/v1.mp4"
    },
    {
        id: 3, title: "Airdrop", desc: "Earn free tokens from partnered projects just by engaging - no spending required.", image: "https://tinyblock.s3.ap-southeast-1.amazonaws.com/v3.mp4"
    },
    { id: 4, title: "Gamehub", desc: "Discover & access top-tier Web3 games with early rewards and in-game perks.", image: "https://tinyblock.s3.ap-southeast-1.amazonaws.com/v4.mp4" },
];

const WhyChooseUs = () => {

    const [nav1, setNav1] = useState<any>(null);
    const [nav2, setNav2] = useState<any>(null);
    const sliderRef1 = useRef<any>(null);
    const sliderRef2 = useRef<any>(null);

    useEffect(() => {
        if (sliderRef1.current && sliderRef2.current) {
            setNav1(sliderRef1.current);
            setNav2(sliderRef2.current);
        }
        AOS.init({ duration: 800 });
    }, []);

  function NextArrow(props: any) {
    const { onClick } = props;
    return (
      <div
        className={`p-2 absolute z-50 cursor-pointer hover:scale-110 bg-white shadow-[0px_8px_16px_0px_rgba(0,148,255,0.3)]
           ${isTablet ? "-bottom-48 right-1/3" : isMobile ? "-bottom-52 right-1/4" : "top-1/2 right-[4vw] lg:right-[10vw]"}`}
      >
        <div className="slider-arrow" onClick={onClick} data-aos="fade-left">
          <IoIosArrowForward size={28} />
        </div>
      </div>
    );
  }

  function PrevArrow(props: any) {
    const { onClick } = props;
    return (
      <div
        className={`p-2 absolute z-50 cursor-pointer hover:scale-110 bg-white shadow-[0px_8px_16px_0px_rgba(0,148,255,0.3)]
           ${isTablet ? "-bottom-48 left-1/3" : isMobile ? "-bottom-52 left-1/4" : "top-1/2 left-[4vw] lg:left-[10vw]"}`}
      >
        <div className="slider-arrow" onClick={onClick} data-aos="fade-right">
          <IoIosArrowBack size={28} />
        </div>
      </div>
    );
  }

    return (
        <div className="main-why-us !pb-[60px]">
            <div className="wrap-us">
                <div className="title" data-aos="fade-up">Why Choose Us?</div>
                <div className="swrap-slider">
                    <div className="slide-top">
                        <Slider
                            asNavFor={nav2!}
                            ref={sliderRef1}
                            slidesToShow={1}
                            arrows={true}
                            dots={false}
                            nextArrow={<NextArrow />}
                            prevArrow={<PrevArrow />}
                            autoplay={true}
                            autoplaySpeed={3000}
                            speed={1000}
                        >
                            {items.map((item) => (
                                <div className="box-img" key={item.id} data-aos="zoom-in">
                                    <video
                                        playsInline
                                        webkit-playsinline
                                        autoPlay
                                        muted
                                        loop
                                    >
                                        <source
                                            src={item.image}
                                            type="video/mp4" />
                                    </video>
                                </div>
                            ))}
                        </Slider>
                    </div>

                    <div className="slider-bottom">
                        <Slider
                            asNavFor={nav1!}
                            ref={sliderRef2}
                            slidesToShow={isTablet || isMobile ? 1 : 3}
                            swipeToSlide={true}
                            focusOnSelect={true}
                            centerMode={isTablet || isMobile ? false : true}
                            arrows={false}
                            dots={true}
                            autoplay={true}
                            autoplaySpeed={3000}
                            speed={1000}
                        >
                            {items.map((item) => (
                                <div className="item-content" key={item.id} data-aos="fade-right">
                                    <div className="content-box">
                                        <div className="line-top">
                                            <img src="./images/line-top.png" alt="" />
                                        </div>
                                        <div className="line-bot">
                                            <img src="./images/line-bot.png" alt="" />
                                        </div>
                                        <div className="text">{item.id}. {item.title}</div>
                                        <div className="desc">{item.desc}</div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WhyChooseUs;
